import { Link } from "react-router-dom";
import { Check, Heart } from "lucide-react";

const OAuthSuccessPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF7F2] font-body flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-green-500 flex items-center justify-center mx-auto mb-6">
          <Check className="w-10 h-10 text-white" />
        </div>
        
        <h1 className="font-heading text-3xl text-[#2D2D2D] mb-4">
          Google Sheets verbunden!
        </h1>
        
        <p className="text-[#6B6B6B] mb-8">
          Alle Vendor- und Sponsor-Bewerbungen werden jetzt automatisch in dein Google Sheet geschrieben.
        </p>
        
        <Link 
          to="/pass"
          className="inline-flex items-center gap-2 px-6 py-3 bg-[#8B2332] text-white rounded-full font-medium hover:bg-[#7A1E2B] transition-colors"
        >
          <Heart className="w-4 h-4" />
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
};

export default OAuthSuccessPage;
